export default __webpack_public_path__ + "static/open-graph-b580f0266cc3f0589d0dc10765bc1631.jpg";